import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';
import { ImportService } from '@services/imports/import.service';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { DataTableEvent } from '../data-table/data-table.component';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'application-generation',
  templateUrl: './application-generation.component.html',
  styleUrls: ['./application-generation.component.scss'],
  providers: [ImportService, ImportTypeService],
  standalone: false
})
export class ApplicationGenerationComponent implements OnInit {
  translations: any;
  public importColumns = [{ prop: 'title' }];

  public importAvailableForCreation = [{ id: '568d17b790202abd16251c62', type: 'weather' }, { id: '564f48a97709514b6660d871', type: 'publicTransport' }];

  public newImport: any = { title: null, fields: {} };
  error: string = null;

  stops: any = [];
  currentSearchTerm;

  selectedIndex = 0;
  possibleAppTypes = ['dynamicContent', 'import', 'special'];
  app: {
    type: string, subType: string, title: string, subTypeTitle: string,
    imports: { id: string, title: string, importProperties: any }[], snippetId: string, languageSpecific: boolean, importsByLanguage: {}, newImport: boolean
  } = {
    type: null, subType: null, title: null, subTypeTitle: null, imports: [], snippetId: null, languageSpecific: false, importsByLanguage: {}, newImport: false
  };
  dynamicContentTypes = [
    { value: 'information', title: 'Informationen' }, { value: 'activity', title: 'Aktivitäten' }, { value: 'alphabet', title: 'Alphabet' }, { value: 'offer', title: 'Angebote' },
    { value: 'breaking-news', title: 'Breaking News' }, { value: 'event', title: 'Events' }, { value: 'feedback', title: 'Feedback' }, { value: 'gallery', title: 'Gallery' },
    { value: 'gastronomy', title: 'Gastronomie' }, { value: 'memory', title: 'Memory' }, { value: 'new', title: 'News' }, { value: 'public-transport', title: 'Öffentlicher Verkehr' },
    { value: 'opening-hours', title: 'Öffnungszeiten' }, { value: 'person', title: 'Personen' }, { value: 'quiz', title: 'Quiz' }, { value: 'restaurant', title: 'Restaurants' },
    { value: 'screensaver', title: 'Screensaver' }, { value: 'social-media', title: 'Social Media' }, { value: 'ticker', title: 'Ticker' }, { value: 'voting', title: 'Voting' },
    { value: 'webcam', title: 'Webcams' }, { value: 'important-numbers', title: 'Wichtige Nummern' }, { value: 'roomservice', title: 'Zimmerservice' }
  ];

  specialAppTypes = [
    { value: '5f96cf768f14f810aa42785f', title: 'Vier gewinnt' },
    { value: '60e30d3ef12e02362529a43a', title: 'Profil | Einstellungen' },
    { value: '64f71405d63ba27ca95aec7f', title: 'Dienstplan' },
    { value: '626ab370d6feec0fdd35af13', title: 'Nimm mich mit (ibextouch)' },
    { value: '610a9367cb8fa80fec227bc2', title: 'Web App teilen (ibexsmart)' }
  ]

  constructor(
    public dialogRef: MatDialogRef<ApplicationGenerationComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private translateService: TranslateService,
    public importService: ImportService, public importTypeService: ImportTypeService, private http: HttpClient
  ) {
  }

  ngOnInit() {
    this.app = this.data?.app ? this.data.app : this.app;
  }

  async save() {
    if (!this.app?.type || !this.app?.title) {
      this.error = this.translateService.get('customerWizard.error.insufficientAppData');
      return;
    }
    this.error = null;
    this.app.title = this.app.title.indexOf('(') > -1 ? this.app.title = this.app.title.split('(')[0].trim() : this.app.title;
    this.dialogRef.close(this.app);
  }

  abort() {
    this.dialogRef.close();
  }

  public onCustomImportType(event: DataTableEvent) {
    this.app.subType = event.row._id;
    this.app.subTypeTitle = event.row.title;
  }

  public assignImport(event: DataTableEvent, lang?) {
    (lang ? (this.app.importsByLanguage[lang] ??= []) : this.app.imports).push({ id: event.row._id, title: event.row.title, importProperties: event.row.importProperties });
  }

  public getAvailableImport(): any {
    return !!this.importAvailableForCreation.find(i => i.id === this.app?.subType);
  }

  selectStop(event) {
    this.newImport.stop = structuredClone(this.stops.find(s => s.stopId === event.option.value));
    this.currentSearchTerm = null;
  }

  async searchStop() {
    await new Promise(r => setTimeout(r, 50));
    if (this.currentSearchTerm?.length > 3) {
      try {
        this.stops = await this.http.get('https://sbb.ibexfusion.com/searchStop/' + this.currentSearchTerm).toPromise();
      } catch (err) {
        console.warn(err);
      }
    }
  }
}
